export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const SRC_PLAN_NOT_SPECIFIED_ERROR_MSG =
  'Please select a source package';
export const DESTINATION_PLAN_NOT_SPECIFIED_ERROR_MSG =
  'Please select a destination package';
export const ORGS_NOT_SELECTED_ERROR_MSG = 'Please select organizations';
export const SAME_PLAN_ERROR_MSG =
  'Source and destination packages should be different';
